<!--  -->
<template>
  <div>
    <div>
      <vxe-modal
        v-model="editReceivingModal"
        width="1300"
         height="700"
      position="center"
        title="编辑承运人货物交接结算确认"
        showFooter
        destroy-on-close
      >
        <p slot="title" class="box-tit-211130">
          <span>编辑承运人货物交接结算确认</span>
        </p>
        <div class="infoPaddingCss add-box">
          <div>
            <div class="flexButton">
              <span class="fontWeight">个人信息</span>
              <vxe-button @click="changeOrder">更换已关联订单</vxe-button>
            </div>
            <vxe-table auto-resize border="inner" :data="orderTableData" align="center">
              <vxe-table-column field="chainNum" title="主订单编号">
                <template slot-scope="{ row }">
                  <a @click="showChainDetail(row)">{{ row.chainNum }}</a>
                </template>
              </vxe-table-column>
              <vxe-table-column field="ordersSellerNum" title="子订单编号" show-overflow>
                <template slot-scope="{ row }">
                  <a @click="showSellerDetail(row)">{{ row.ordersSellerNum}}</a>
                </template>
              </vxe-table-column>
              <vxe-table-column field="sellerName" title="承运人名称" show-overflow></vxe-table-column>
              <vxe-table-column title="平台企业"  field="compName">
                <template v-slot="{ row }">
                  <platform-corp
                    :row="row"
                    :field="'compName'"
                    :placeholder="'请选择平台企业'"
                    v-if="row.ordersSellerId ==null"
                  ></platform-corp>
                  <span v-else>{{row.compName}}</span>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div style="margin-top: 10px;">
            <div class="flexButton">
              <span class="fontWeight">物流信息</span>
              <vxe-button @click="changeLogistic">更换已关联物流信息</vxe-button>
            </div>
            <vxe-table
              auto-resize
              border="inner"
              :data="logisticsShowData"
              stripe
              highlight-hover-row
            >
              <vxe-table-column field="id" title="序号"></vxe-table-column>

              <vxe-table-column field="logisticsNum" title="物流编号" show-overflow>
                <template slot-scope="{ row }">
                  <span
                    @click="showLogisticsDetail(row)"
                    style="cursor:pointer;color: #2d8cf0;"
                  >{{ row.logisticsNum }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column field="logisticsCode" title="物流单号" show-overflow></vxe-table-column>
              <vxe-table-column field="goodsName" title="货物名称" show-overflow></vxe-table-column>
              <vxe-table-column field="goodsRule" title="规格"></vxe-table-column>
              <vxe-table-column field="realCount" title="实际数量"></vxe-table-column>
              <vxe-table-column field="goodsUnit" title="单位"></vxe-table-column>
              <vxe-table-column field="carShipNum" title="车船号" show-overflow>
                <template slot-scope="{ row }">
                  <span
                    v-if="row.trackUrl || row.logisticsType === 2"
                    @click="getMap(row)"
                    style="color: #2D8CF0;cursor:pointer"
                  >{{ row.carShipNum }}</span>
                  <span v-if="!row.trackUrl && row.logisticsType !== 2 ">{{ row.carShipNum }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column field="voyage" title="航次号" show-overflow></vxe-table-column>
              <vxe-table-column field="deliveryPlace" title="交货地点"></vxe-table-column>
              <vxe-table-column field="beginPlace" title="起运地" show-overflow></vxe-table-column>
              <vxe-table-column field="beginTime" title="起运时间" width="100">
                <template slot-scope="{ row }">
                  <span style="color: #a7adad">{{ row.beginTime | timePartRule }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column field="endPlace" title="到达地" show-overflow></vxe-table-column>
              <vxe-table-column field="endTime" title="到达时间" width="100">
                <template slot-scope="{ row }">
                  <span style="color: #a7adad">{{ row.endTime | timePartRule }}</span>
                </template>
              </vxe-table-column>
            </vxe-table>
            <vxe-pager
              background
              size="small"
              :current-page.sync="currentPage2"
              :page-size.sync="pageSize2"
              :total="totalResult2"
              @page-change="handleCurrentChange2"
            ></vxe-pager>
          </div>
          <div style="margin-top: 10px;" class="infoPaddingCss">
            <div class="flexButton">
              <span class="fontWeight">结算信息</span>
            </div>
            <vxe-table
              auto-resize
              border="inner"
              ref="xTable"
              :data="receivingTableData"
              :edit-rules="formRules"
              :edit-config="{trigger: 'click', mode: 'cell'}"
            >
              <vxe-table-column field="addTime" title="结算时间">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.addTime" placeholder="选择日期" type="date" transfer></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="goodsName" title="货名">
                <template v-slot="{row}">
                  <vxe-input v-model="row.goodsName" placeholder="必填" @blur="clearTableV"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="goodsRule" title="规格">
                <template v-slot="{row}">
                  <vxe-input v-model="row.goodsRule" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="goodsUnit" title="单位">
                <template v-slot="{row}">
                  <!-- <vxe-input v-model="row.goodsUnit" placeholder="选填"></vxe-input> -->
                  <vxe-select
                    v-model="row.goodsUnit"
                    placeholder="请选择"
                    :options="unitTypeOptions"
                    @change="clearTableV"
                    transfer
                  ></vxe-select>
                </template>
              </vxe-table-column>
              <vxe-table-column field="counts" title="实际交接数量">
                <template v-slot="{row}">
                  <vxe-input
                    v-model="row.counts"
                    placeholder="必填"
                    v-on:input="inputcounts(row)"
                    @blur="clearTableV"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="price" title="单价">
                <template v-slot="{row}">
                  <vxe-input
                    v-model="row.price"
                    placeholder="选填"
                    v-on:input="inputcounts(row)"
                    @blur="clearTableV"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="receAmount" title="总金额">
                <template v-slot="{row}">
                  <vxe-input v-model="row.receAmount" placeholder="必填" @blur="clearTableV"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="note" title="摘要">
                <template v-slot="{row}">
                  <vxe-input v-model="row.note" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class="add-box">
            <vxe-table
              border
              show-overflow
              :auto-resize="true"
              class="table-upload-style"
              max-height="200"
              :data="uploadData"
              :edit-config="{trigger: 'click', mode: 'cell'}"
            >
              <vxe-table-column field="url" title="上传附件">
                <template v-slot="{ row }">
                  <upload-list
                    :isEdit="true"
                    :row="row"
                    :initFileList="uploadList"
                    :view="'arrange'"
                  ></upload-list>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
        <div slot="footer">
          <vxe-button
            status="primary"
            style="width:140px;border-radius: 0px;"
            @click="cancelSubmit"
          >取消</vxe-button>
          <vxe-button
            type="submit"
            status="primary"
            @click="submitEdit()"
            style="width:140px;border-radius: 0px;"
          >保存</vxe-button>
        </div>
      </vxe-modal>
    </div>
    <div v-show="trackFlag" class="trackBox">
      <div style="display: flex;justify-content: space-between;">
        <div
          style="margin-left: 10px;font-size: 14px;font-weight: bold;line-height: 30px;"
        >{{isCar ? '车辆轨迹': '船舶轨迹'}}</div>
        <div
          @click="trackFlag = false"
          style="margin-right: 5px;cursor: pointer;line-height: 30px;height: 30px;background: #409EFF;color: #fff;border-radius:5px;width:60px;font-size: 12px;font-size: 12px;text-align: center;"
        >关闭</div>
      </div>
      <iframe
        ref="mapFrame"
        style="width:100%;height:85vh;overflow: hidden;"
        frameborder="0"
        name="showHere"
        scrolling="auto"
        :src="url"
      ></iframe>
      <!--      <iframe-view v-if="!isCar" :obj="shipObj"></iframe-view>-->
    </div>
    <vxe-modal v-model="logisticsVisible" title="选择物流订单" width="1300" height="600" resize remember position="center">
      <choose-logistics
        ref="chooseLogistics"
        @choose="chooseLogistics"
        @close="closeLogistics"
        v-bind:orderTypeTwo="orderTypeTwo"
        v-bind:orderNum="orderNum"
      ></choose-logistics>
    </vxe-modal>
    <vxe-modal v-model="orderVisible" title="选择订单" width="1450" height="600" resize remember position="center">
      <choose-order-two
        ref="chooseOrderTwo"
        @chooseOrder="chooseOrderTwo"
        v-bind:orderType="orderType"
      ></choose-order-two>
    </vxe-modal>
    <vxe-modal
      v-model="logisticDetailVisible"
      title="物流详情"
      width="1300"
       position="center"
      height="600"
      resize
      footer-hide
    >
      <detail-modal ref="modalDetail"></detail-modal>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import DetailModal from "@/views/logistics/DetailModal";
import ChooseLogistics from "@/components/modal/ChooseLogistics";
import ChooseOrderTwo from "@/components/modal/ChooseOrderTwo";
import { showLoading, hideLoading } from "@/utils/util";
import PlatformCorp from "@/components/common/PlatformCorp";

import UploadList from "@/components/common/UploadList";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";
export default {
  components: {
    DetailModal,
    UploadList,
    ChooseLogistics,
    ChooseOrderTwo,
    PlatformCorp,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      orderVisible: false,
      editReceivingModal: false,
      logisticsShowData: [],
      logisticsVisible: false,
      orderTypeTwo: 2,
      orderType: 2,
      orderNum: null,
      currentPage2: 1,
      isCar: true,
      url: null,
      pageSize2: 5,
      totalResult2: 300,
      trackFlag: false,
      deailReceiveNum: null,
      deailCreateUser: null,
      deailCreateTime: null,
      orderTableData: [],
      showPicIndex: 0,
      receivingTableData: [],
      logisticsTableData: [],
      logisticDetailVisible: false,
      uploadData: [
        {
          fileUuidList: [],
        },
      ],
      formRules: {
        goodsName: [{ required: true, message: "请输入货名" }],
        counts: [{ required: true, message: "请输入实际数量" }],
        goodsUnit: [{ required: true, message: "请输入单位" }],
        addTime: [{ required: true, message: "请选择结算时间" }],
        // price: [{ required: true, message: "请输入单价" }],
        receAmount: [{ required: true, message: "请输入总金额" }],
      },
      uploadList: [],
      unitTypeOptions: [],
    };
  },
  filters: {
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
          y +
          "-" +
          m.substring(m.length - 2, m.length) +
          "-" +
          d.substring(d.length - 2, d.length)
        );
      } else {
        return "";
      }
    },
  },
  methods: {
        getDicDate() {
      this.unitTypeOptions = [];

      $api.other.getUnitTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100,
          },
        })
        .then((res) => {
          res.data.forEach((item) => {
            var obj = {
              label: item.dictText,
              value: item.dictText,
            };
            this.unitTypeOptions.push(obj);
          });
        });
    },
    editReceiving(row) {
      if (!this.isHavePermission('seller:ReceDetail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.orderTypeTwo = 2;
      this.getReceivingDetail(row);
      this.editReceivingModal = true;
      this.getDicDate()
    },
    showSellerDetail(row){
      if (!this.isHavePermission('seller:detail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.$router.push(`/order/seller/detail/${row.ordersSellerId}`);
      this.$emit("closeRec", false);
    },
    handleCurrentChange2(val) {
      this.logisticsShowData = this.logisticsTableData.slice(
        (val.currentPage - 1) * val.pageSize,
        val.currentPage * val.pageSize
      );
      console.log(this.logisticsShowData);
    },
    changeLogistic() {
      if (this.orderTableData[0].ordersSellerNum == null) {
        this.$XModal.alert({
          message: "请先选择订单",
          status: "error",
        });
        return;
      }
      this.logisticsVisible = true;
      this.$refs.chooseLogistics.init();
    },
    chooseLogistics(row) {
      console.log(row);
      var self = this;
      this.logisticsTableData = row;
      this.totalResult2 = this.logisticsTableData.length;
      this.logisticsShowData = this.logisticsTableData.slice(0, 5);
      var logisticsIds = [];
      var addcounts = 0;
      row.forEach(function (item, index) {
        addcounts = addcounts + item.realCount;
      });
      if (addcounts && this.receivingTableData[0].price) {
        this.receivingTableData[0].receAmount =
          Math.round(addcounts * this.receivingTableData[0].price * 100) / 100;
      }
      this.receivingTableData[0].counts = Math.round(addcounts * 100) / 100;
      this.logisticsVisible = false;
    },
    chooseOrderTwo(row) {
      var objOrder = {};
      this.orderTableData = [];
      if (this.orderNum != row.sellerOrdersNum) {
        this.logisticsTableData = [];
        this.logisticsShowData = [];
      }
      this.orderNum = row.sellerOrdersNum;
      this.orderTypeTwo = 2;
      objOrder.ordersBuyerNum = row.buyerOrdersNum;
      objOrder.ordersSellerNum = row.sellerOrdersNum;
      objOrder.compName = row.buyerName;
      objOrder.compNameId = row.platformCompanyId;

      objOrder.chainNum = row.chainNum;
      objOrder.sellerName = row.sellerName;
      objOrder.createUser = row.createUser;
      objOrder.createTime = row.createTime;
      // objOrder.ordersBuyerId = row.id;
      objOrder.chainId = row.chainId;
      objOrder.ordersSellerId = row.id;
      // objOrder.ordersSellerLv2Id = res.ordersSellerLv2Id;
      this.orderTableData.push(objOrder);
      this.orderVisible = false;
    },
    changeOrder() {
      this.orderVisible = true;
      this.orderType = 2;
      this.$refs.chooseOrderTwo.init();
    },
    async getReceivingDetail(row) {
      var self = this;
      self.currentPage2 = 1;
      self.pageSize2 = 5;
      self.logisticsShowData = [];
      self.receivingTableData = [];
      self.deailReceiveNum = row.receiveNum;
      self.deailCreateUser = row.createUser;
      self.orderTypeTwo = 2;
      self.deailCreateTime = row.createTime;
      self.orderTableData = [];
      self.editUuidList = [];
      self.uploadList = [];
      var objReceive = {};
      var objOrder = {};
      var data = {
        id: row.id,
      };
      let response = await $api.receiving.request(
        "querySellerReceiveGoodsDetail",
        data
      );
      if (response.status == 1) {
        let res = response.data;
        //结算信息
        // objReceive.addTime = res.addTime;
        objReceive.addTime = this.$utils.toDateString(
          res.addTime,
          "yyyy-MM-dd"
        );
        objReceive.compName = res.compName;
        objReceive.compNameId = res.platformCompanyId;
        objReceive.goodsName = res.goodsName;
        objReceive.id = res.id;
        objOrder.chainNum = res.chainNum;
        objOrder.chainId = res.chainId;
        objReceive.goodsRule = res.goodsRule;
        objReceive.goodsUnit = res.goodsUnit;
        objReceive.counts = res.counts;
        objReceive.price = res.price;
        objReceive.receAmount = res.receAmount;
        objReceive.note = res.note;
        self.receivingTableData.push(objReceive);
        console.log(self.receivingTableData);
        //订单信息
        objOrder.compName = res.compName;
        objOrder.compNameId = res.platformCompanyId;
        objOrder.ordersBuyerNum = res.ordersBuyerNum;
        objOrder.ordersSellerNum = res.ordersSellerNum;
        objOrder.ordersSellerLv2Num = res.ordersSellerLv2Num;
        self.orderNum = res.ordersSellerNum;
        objOrder.receiveName = res.receiveName;
        objOrder.sendName = res.sendName;
        objOrder.createUser = res.createUser;
        objOrder.createTime = res.createTime;
        objOrder.ordersBuyerId = res.ordersBuyerId;
        objOrder.ordersSellerId = res.ordersSellerId;
        objOrder.ordersSellerLv2Id = res.ordersSellerLv2Id;
        objOrder.compName = res.compName;
        objOrder.buyerName = res.buyerName;
        objOrder.sellerName = res.sellerName;
        self.orderTableData.push(objOrder);
        //物流信息
        self.logisticsTableData = res.logisticsList;
        self.totalResult2 = self.logisticsTableData.length;
        self.logisticsShowData = self.logisticsTableData.slice(0, 5);
        //图片信息
        if (res.fileList != null) {
          res.fileList.map((i) => {
            self.editUuidList.push(i.uuid);
            self.uploadList.push(i);
          });
        }
      }
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    getMap(row) {
      if (row.logisticsType === 1) {
        this.isCar = true;
        this.seeCarMap(row);
      } else {
        this.isCar = false;
        this.seeShipMap(row);
      }
    },
    seeCarMap(row) {
      let that = this;
      this.trackFlag = true;
      this.url = '/carShip/fwCarFrame';
      this.$nextTick(function () {
        setTimeout(function () {
          let mapFrame = that.$refs.mapFrame;
          let iframeWin = mapFrame.contentWindow;
          iframeWin.postMessage(JSON.stringify({carInfo: row, logistics: true, top: true}), '*');
        }, 5000);
      });
    },
    seeShipMap(row) {
      let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
      if (mmsi == null || mmsi === '') {
        //暂无数据
        this.$Message.error('暂无数据');
        return
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi
      }
      this.trackFlag = true;
      let that = this;
      if (this.url === '/carShip/fwShipFrame') {
        let mapFrame = that.$refs.mapFrame;
        let iframeWin = mapFrame.contentWindow
        iframeWin.postMessage(JSON.stringify(obj), '*')
      } else {
        this.url = '/carShip/fwShipFrame';
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow
            iframeWin.postMessage(JSON.stringify(obj), '*')
          }, 5000);
        });
      }
    },
    // 船舶日期往前推N天
    dateAddDays(dataStr, dayCount) {
      let isdate = new Date(dataStr.replace(/-/g, "/"));
      isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
      let strMonth = isdate.getMonth() + 1;
      let strDate = isdate.getDate();
      let strYear = isdate.getFullYear();
      if (strMonth >= 1 && strMonth <= 9) {
        strMonth = "0" + strMonth;
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return strYear + "-" + strMonth + "-" + strDate;
    },
    showLogisticsDetail(row) {
      if (!this.isHavePermission('logistics:queryLogisticsDetail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.logisticDetailVisible = true;
      this.$refs.modalDetail.queryLogisticsDetail(row.id);
    },
    clickFile(url) {
      window.open(url);
    },
    showChainDetail(row) {
      if (!this.isHavePermission('chain:detail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.$router.push(`/order/detail/${row.chainId}`);
      this.$emit("closeRec", false);
    },
    showBuyerDetail(row) {
      if (!this.isHavePermission('buyer:detail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.$router.push(`/order/sales/detail/${row.ordersBuyerId}`);
      this.$emit("closeRec", false);
    },
    cancelSubmit() {
      this.editReceivingModal = false;
    },
    inputcounts(row) {
      if (row.counts) {
        if (row.price) {
           this.receivingTableData[0].receAmount = Math.round(row.counts * row.price * 100) / 100;
        }
      }
    },
    closeLogistics() {
      this.logisticsVisible = false;
    },
    async validEvent() {
      let errMap = await this.$refs.xTable.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async submitEdit() {
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({ status: "error", message: "校验不通过！" });
        return;
      }
      var tempCopy = {
        logisticsIdList: [],
      };
      if (this.receivingTableData[0].addTime) {
        tempCopy.addTime = this.$utils.timestamp(
          this.receivingTableData[0].addTime
        );
      }
      tempCopy.id = this.receivingTableData[0].id;
      tempCopy.receAmount = this.receivingTableData[0].receAmount;
      tempCopy.counts = this.receivingTableData[0].counts;
      tempCopy.price = this.receivingTableData[0].price;
      tempCopy.goodsName = this.receivingTableData[0].goodsName;
      tempCopy.note = this.receivingTableData[0].note;
      tempCopy.compName = this.orderTableData[0].compName;
      tempCopy.compNameId = this.orderTableData[0].platformCompanyId;
      tempCopy.goodsRule = this.receivingTableData[0].goodsRule;
      tempCopy.goodsUnit = this.receivingTableData[0].goodsUnit;
      tempCopy.ordersBuyerId = this.orderTableData[0].ordersBuyerId;
      tempCopy.ordersSellerId = this.orderTableData[0].ordersSellerId;
      tempCopy.ordersSellerLv2Id = this.orderTableData[0].ordersSellerLv2Id;
      tempCopy.fileUuidList = this.uploadData[0].fileUuidList;
      this.logisticsTableData.forEach(function (item, index) {
        tempCopy.logisticsIdList.push(item.id);
      });
      console.log(tempCopy);
      showLoading();
      let res = await $api.receiving.request(
        "updateSellerReceiveGoods",
        tempCopy
      );
      hideLoading();
      if (res.status == 1) {
        this.$Message["success"]({
          background: true,
          content: "更新成功",
        });
        this.editReceivingModal = false;
        this.$emit("updateList", true);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
  },
};
</script>
<style>
.trackBox {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 100;
  background: #fff;
}
/* .flexButton {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
} */
.pdf-box1 {
  display: inline-block;
  position: relative;
  line-height: 60px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  width: 60px;
  height: 60px;
  overflow: hidden;
}
.infoPaddingCss .vxe-pager .vxe-pager--sizes {
  width: 7em;
  text-align: center;
  cursor: pointer;
  display: none;
}

</style>
